import browserCheck from './browser-check';
import { captiveNetworkAssistantCheck } from '@/captive-network-assistant-check';

let canProceed = true;

function showPreInitErrorScreen() {
    document.body.insertAdjacentHTML(
        'beforeend',
        `
  <div id="preInitUnhandledErrorScreen">
    <div>Unhandled error while loading app</div>
  </div>`
    );
}

function inFacebookLoginPopup() {
    if (location.href.indexOf('oauth-redirect') !== -1) {
        return true;
    } else {
        return false;
    }
}

function myErrorHandler(errorMsg, url, lineNumber) {
    // NOTE: An error occured BEFORE running browserCheck. Probably an error from another place, for instance initialize.js
    // We can assume that the user is running an old browser, that would have gotten a browsercheck popup anyway.

    if (!canProceed) {
        return;
    }
    browserCheck(() => {
        // NOTE: Will get here, if browsercheck passed
        showPreInitErrorScreen();
    }, true /* hide ignore button */);
}
window.addEventListener('error', myErrorHandler);

if (inFacebookLoginPopup()) {
    canProceed = false;
}

if (captiveNetworkAssistantCheck()) {
    canProceed = false;

    document.body.insertAdjacentHTML(
        'beforeend',
        `
  <div id="captiveNetworkAssistantScreen" class="CNA">
    <div class="CNA__flexspacer"></div>
    <div class="CNA__messageBox">
      <div class="CNA__title">
        Ojsann!
      </div>
      <div class="CNA__subtitle">
        Du sitter fast i en begrenset nettleser.
      </div>
      <div class="CNA__text">
        Kopier lenken og bruk Safari for å starte:
      </div>
      <div class="CNA__linkCont">
        <input class="CNA__link" value="memolife.com/ft">
        <div class="CNA__copyInstruction state-1">Klikk for å kopiere lenken</div>
        <div class="CNA__copyInstruction state-2">Lenken er kopiert</div>
      </div>
      <div class="CNA__haveFun">
        Ha det gøy!
      </div>
    </div>
    <div class="CNA__flexspacer"></div>
    <div class="CNA__logos">
      <div class="CNA__memolifeLogo">
        <div class="CNA__memolifeLogoHeart"></div>
        <div class="CNA__memolifeLogoText"></div>
      </div>
      <div class="CNA__flytogetLogo">
      </div>
    </div>
  </div>`
    );

    let inputElem = document.querySelector('.CNA__link');
    let linkContElem = document.querySelector('.CNA__linkCont');
    linkContElem.onclick = () => {
        let range = document.createRange();
        range.selectNodeContents(inputElem);
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        inputElem.setSelectionRange(0, 999999);

        document.execCommand('copy');
        inputElem.blur();
        linkContElem.classList.add('is-copied');
    };
}

function showGlobalLoadingScreen() {
    document.body.insertAdjacentHTML(
        'beforeend',
        `
  <div id="globalLoadingScreen" class="splash default-splash">
    <div class="heart"></div>
  </div>`
    );
}

export default function () {
    window.removeEventListener('error', myErrorHandler);

    return new Promise(resolve => {
        if (canProceed) {
            browserCheck(() => {
                showGlobalLoadingScreen();
                resolve(true);
            });
        } else {
            resolve(false);
        }
    });
}
